import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {UUID} from '../../shared/types/uuid.type';
import {StreamTranscodingConfiguration} from '../../services/api/stream-transcoding-configurations';

export interface StreamTranscodingConfigurationsState extends EntityState<StreamTranscodingConfiguration> {
  // Loading states
  loading: boolean;
  creating: boolean;
  updating: { [id: string]: boolean };
  deleting: { [id: string]: boolean };

  // Error states
  error: string | null;
  createError: string | null;
  updateError: { [id: string]: string | null };
  deleteError: { [id: string]: string | null };

  // Metadata
  loaded: boolean;
  lastUpdated: number | null;
  selectedId: string | null;
}

export const streamTranscodingConfigurationsAdapter: EntityAdapter<StreamTranscodingConfiguration> =
  createEntityAdapter<StreamTranscodingConfiguration>({
    selectId: (config: StreamTranscodingConfiguration): UUID => config.id,
    sortComparer: (a: StreamTranscodingConfiguration, b: StreamTranscodingConfiguration): number => b.createdAt - a.createdAt
  });

export const initialStreamTranscodingConfigurationsState: StreamTranscodingConfigurationsState =
  streamTranscodingConfigurationsAdapter.getInitialState({
    loading: false,
    creating: false,
    updating: {},
    deleting: {},
    error: null,
    createError: null,
    updateError: {},
    deleteError: {},
    loaded: false,
    lastUpdated: null,
    selectedId: null
  });
